var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 15.1666C4.04659 15.1666 0.833252 11.9533 0.833252 7.99992C0.833252 4.04659 4.04659 0.833252 7.99992 0.833252C11.9533 0.833252 15.1666 4.04659 15.1666 7.99992C15.1666 11.9533 11.9533 15.1666 7.99992 15.1666ZM7.99992 1.83325C4.59992 1.83325 1.83325 4.59992 1.83325 7.99992C1.83325 11.3999 4.59992 14.1666 7.99992 14.1666C11.3999 14.1666 14.1666 11.3999 14.1666 7.99992C14.1666 4.59992 11.3999 1.83325 7.99992 1.83325Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4733 10.6199C10.3867 10.6199 10.3 10.5999 10.22 10.5466L8.15334 9.31326C7.64001 9.00659 7.26001 8.33326 7.26001 7.73992V5.00659C7.26001 4.73326 7.48668 4.50659 7.76001 4.50659C8.03334 4.50659 8.26001 4.73326 8.26001 5.00659V7.73992C8.26001 7.97992 8.46001 8.33326 8.66668 8.45326L10.7333 9.68659C10.9733 9.82659 11.0467 10.1333 10.9067 10.3733C10.8067 10.5333 10.64 10.6199 10.4733 10.6199Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.465832c932120c0199a04fe295a93ba2.svg";
export { ForwardRef as ReactComponent };